export interface EpisodeModel {
  id: string;
  title: string;
  banner: string;
  url: string;
  duration: number;
  date: string;
}
